module.exports = "<ion-router-outlet main></ion-router-outlet>\r\n"